import * as React from "react";
import useMobileBreakpoint from "@arctheme-hooks/useMobileBreakpoint";
import {Image} from "@arctheme-components/elements/Image/Image";
import {Link} from "@arctheme-components/elements/Link/Link";

export const MegamenuFeaturedImage = ({
  blockItem,
  index,
  settings,
}) => {
  const isMobile = useMobileBreakpoint(settings.section.mobile_breakpoint);

  let imageWidth = settings.section.image_width;
  if (imageWidth == 0) {
    imageWidth = "100%";
  }
  let imageHeight = settings.section.image_height;
  if (imageHeight == 0) {
    imageHeight = "100%";
  }

  // Check if mobile_image is available and use it, otherwise use the default image
  let imageUrl = blockItem.image?.src ?? blockItem.image;
  if (isMobile) {
    imageUrl = blockItem.mobile_image
      ? blockItem.mobile_image
      : blockItem.image?.src ?? blockItem.image;
  }

  return (
    <div
      key={`cta-${index}`}
      className="megamenu__cta-container relative h-full"
    >
      <div className={`megamenu__cta-item`}>
        <div className="w-full h-full">
          <a href={blockItem.url}>
            <Image
              imageUrl={imageUrl}
              classes="w-full h-full object-cover"
              alt={blockItem?.title}
            />
          </a>
        </div>
        <div className={`${blockItem.layout} flex`}>
          {blockItem?.title && (
            <div className={`${blockItem.button_style}`}>
              {blockItem?.title}
            </div>
          )}
          {blockItem?.button_text && (
            <Link
                link={blockItem.url}
                classes={`megamenu__cta-item-button items-center flex ${blockItem.button_style}`}
            >
              {blockItem?.button_text}
            </Link>
          )}
          <i className={`icon ${blockItem.icon}`}></i>
        </div>
      </div>
    </div>
  );
};
